module.exports = __webpack_public_path__ + "interactiveApp/KurzByk/media/11 Predni klizka vcelku.jpg";